export const appsAppGroupIdUserImportsImportIdSearchEventCatalog =
  "/apps/:app_group_id/user_imports/:import_id/search_event_catalog";
